import React from 'react'
import JiaMengHeader from '@components/JiaMeng/Header/Stats'
import { asyncLoad } from '@util'

const AsyncStats = asyncLoad(() => import('@components/JiaMeng/Stats'))

export default {
  path: 'stats',
  component: props => <JiaMengHeader key="stats" {...props} />,
  indexRoute: {
    component: AsyncStats
  },
  stat: '加盟店数据/首页'
}
